import { gql } from "@apollo/client";

export const SEND_MULTIPLE_FOR_INTERPRETATION_WITH_TEMPLATE = gql`
  mutation sendMultipleForInterpretationWithTemplate(
    $input: SendMultipleForInterpretationWithTemplateInput!
    $clientIdentifier: String!
  ) {
    documentHandler {
      sendMultipleForInterpretationWithTemplate(
        input: $input
        clientIdentifier: $clientIdentifier
      ) {
        success
        results {
          documentId
          interpretationId
          isSuccessful
        }
      }
    }
  }
`;
